import React from "react";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import ProfileModal from "../ProfileModal";
import Actions from "../../redux/actions";
import getEncodedImageUrl from "../../helpers/getEncodedImageUrl";

const UserDetails = ({ userProfile, dispatch, intl, locale, setLocale }) => {
  const [show, setShow] = React.useState(false);
  const [mini, setMini] = React.useState(true);
  const [showDropdown, setShowDropdown] = React.useState(false);

  React.useEffect(() => {
    if (localStorage.getItem("logged_in") === "true") {
      setMini(false);
      setTimeout(() => setMini(true), 4000);
      localStorage.removeItem("logged_in");
    }
  }, []);

  const logout = () => {
    dispatch(Actions.userLogout());
    //window.location.href = process.env.REACT_APP_WP_SITE_ROOT;
     window.location.reload();
  };
  return (
    <React.Fragment>
      <div
        className="user-details-container"
        onMouseEnter={() => setShowDropdown(true)}
        onMouseLeave={() => setShowDropdown(false)}
      >
        <div
          className={`dash-user-details text-left ${mini ? "mini-dash" : ""}`}
        >
          <Button variant="link" onClick={() => setShow(true)}>
            <img
              className="userimage"
              src={
                userProfile.photo
                  ? getEncodedImageUrl(userProfile.photo, 60, 60)
                  : `https://ui-avatars.com/api/?name=${userProfile.firstName}+${userProfile.lastName}&size=200&color=ff7142`
              }
              alt={`${userProfile.firstName} ${userProfile.lastName}`}
            />
            <div className="user-log">
              <FormattedMessage id="user.welcome" />
              <h5>
                {userProfile.firstName} {userProfile.lastName}
              </h5>
            </div>
          </Button>
          <div className="credits-log">
            <Button variant="link">
              <img alt="" src="/icons/chev-down.png" />
            </Button>
            <span className="creds">{userProfile.credits}</span>
            <FormattedMessage id="user.creds" />{userProfile.credits > 2 ? 's' : ''}
            <img className="m-l-20" src="/images/creds.png" alt="cred img" />
          </div>
        </div>
        <div className={showDropdown ? "user-dropdown show" : "user-dropdown"}>
          <Button onClick={() => setShow(true)}>Information</Button>
          <Button onClick={() => logout()}>Logout</Button>
          <div className="locale-container">
            <Button onClick={() => setLocale('fr')} className={locale === 'fr' ? 'active-locale' : ''}>
              <img
                alt="French"
                src="https://www.e-slides.net/wp-content/plugins/wpglobus/flags/fr.png"
              />
            &nbsp;FR
          </Button>
            <Button onClick={() => setLocale('en')} className={locale === 'en' ? 'active-locale' : ''}>
              <img
                alt="English"
                src="https://www.e-slides.net/wp-content/plugins/wpglobus/flags/us.png"
              />
            &nbsp;EN
          </Button></div>
        </div>
      </div>
      <ProfileModal show={show} setShow={(bool) => setShow(bool)} />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.user.profile,
});
export default connect(mapStateToProps)(UserDetails);
